import { FC } from "react";
import classNames from "classnames";

import s from "./Spacer.module.scss";

interface SpacerProps {
  size?: "xs" | "s" | "m" | "l" | "xl";
  children?: React.ReactNode;
}

export const Spacer: FC<SpacerProps> = ({ size = "m", children }) => {
  return (
    <div
      className={classNames(s.Spacer, {
        [s.XSmall]: size === "xs",
        [s.Small]: size === "s",
        [s.Large]: size === "l",
        [s.XLarge]: size === "xl",
      })}
    >
      {children}
    </div>
  );
};
